export default "__VITE_ASSET__B8RVt2$K__"